import { render, staticRenderFns } from "./GeneralProcessComponent.vue?vue&type=template&id=673ec3e6&"
import script from "./GeneralProcessComponent.vue?vue&type=script&lang=js&"
export * from "./GeneralProcessComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports